import { render } from "./completed-sales.vue?vue&type=template&id=1d0c0e7c"
import script from "./completed-sales.vue?vue&type=script&lang=js"
export * from "./completed-sales.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__